<template>
  <div>
    <div
      class="local-loader__wrapper"
      :style="{
        width: defaultWidth + 'px',
        height: defaultHeight + 'px',
      }"
    >
      <div class="local-loader__spinner">
        <div class="local-loader__spinner-inner">
          <div />
        </div>
      </div>
    </div>
    <div ref="localChild">
      <slot />
    </div>
  </div>
</template>
<script lang="ts">
import get from 'lodash.get';

export default {
  name: 'LocalLoader',
  data() {
    return {
      defaultWidth: 0,
      defaultHeight: 0,
      throttle: null,
    };
  },
  computed: {
    items() {
      return Array.from({ length: this.length }).map((_, index) => index);
    },
  },
  mounted() {
    this.throttle = setInterval(() => this.setSize(), 50);
  },
  unmounted() {
    clearInterval(this.throttle);
  },
  methods: {
    setSize() {
      this.defaultWidth = get(this.$refs, 'localChild.clientWidth', 0);
      this.defaultHeight = get(this.$refs, 'localChild.clientHeight', 0);
    },
  },
};
</script>

<style src="./LocalLoader.scss" lang="scss" scoped />
